import { Content } from "@/ui";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { getRoute } from "@/functions/getRoute";
import { getRelatedJobs } from "@/functions/getRelatedJobs";
import sn from "@/snippets";

export default function FrequentlyAskedQuestionsPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps() {
  const parent = simple_pages_helper.find("fa730d92-776a-4cc4-b7ff-82148a091900", "id");
  const jobs = getRelatedJobs({ page: parent });

  return {
    props: {
      meta: {},
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              {
                label: `Find A Job`,
                href: getRoute("dynamic", { url_slugs: ["jobs"] }),
              },
              {
                label: `Clinical Assessor Jobs`,
                href: getRoute("dynamic", { url_slugs: ["find-a-job","clinical-assessor-jobs"] }),
              },
            ],
          },
        },
        {
          component: "Header",
          props: {
            title: {
              path: `page.${parent.url_slug}.faqs.component.Header.title`,
              placeholder: `${parent.title} FAQs`,
            },
            description: {
              path: `page.${parent.url_slug}.faqs.component.Header.description`,
              placeholder: ``,
            },
            back: {
              path: `page.${parent.url_slug}.component.Header.back`,
              placeholder: `Back to ${parent.title}`,
              href: "#",
            },
          },
        },
        {
          component: "RichText",
          id: "Intro",
          props: {
            className: "bg-light text-dark py-4 py-md-5",
            body: parent.intro ?? null,
          },
        },
        {
          component: "RichText",
          id: "Body",
          props: {
            className: "bg-light text-dark py-4 py-md-5",
            body: parent.body ?? null,
          },
        },

        {
          component: "TrendingJobs",
          id: "Intro",
          props: {
            title: `${parent.trending_jobs_title}`,
            items:  parent.trending_jobs_items,
          },
        },
        {
          component: "LatestJobs",
          props: {
            title: `${parent.title}`,
            items: jobs,
            urlSlug: "/jobs/#/clinical-assessor"
          },
        },
        {
          component: "Chatbot",
          props: {
            chatbot: parent.chatbot
          },
        },
      ],
    },
  };
}
